// extracted by mini-css-extract-plugin
export var banner = "_i0-0";
export var closeButton = "_i0-2";
export var greenCheckmark = "_i0-3";
export var hereLink = "_i0-4";
export var titleIcon = "_i0-1";